var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { defaultTheme } from "../../../styles/defaultTheme";
import { PickerConfig } from "./PickerConfig";
var overrideTheme = __assign(__assign({}, defaultTheme), { overrides: {
        MuiTypography: {
            h2: {
                fontSize: defaultTheme.typography.h4.fontSize,
            },
        },
    } });
export var PickerConfigProvider = function (props) {
    return (React.createElement(MuiThemeProvider, { theme: overrideTheme },
        React.createElement(MuiPickersUtilsProvider, { utils: PickerConfig, locale: "jp" }, props.children)));
};
